import React, { ButtonHTMLAttributes, DetailedHTMLProps, ReactNode } from 'react';

import './styles.css';
import { Spin } from '../../svg/General';
import { twMerge } from 'tailwind-merge';

export interface Props
  extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  mode?: Mode;
  disabled?: boolean;
  label?: string;
  className?: string;
  children?: ReactNode;
  loading?: boolean;
  icon?: ReactNode;
  leftIcon?: ReactNode;
  classNameSvg?: string;
  ariaLabel?: string;
}

type Mode =
  | 'button-primary'
  | 'button-secondary'
  | 'button-simple'
  | 'button-transparent'
  | 'button-tertiary'
  | 'button-event-game'
  | 'button-deposit'
  | 'button-base'
  | 'button-border-light';

export const Button = React.forwardRef(
  (
    {
      mode = 'button-primary',
      className,
      disabled,
      label,
      children,
      onClick,
      loading,
      icon,
      leftIcon,
      classNameSvg,
      ...restProps
    }: Props,
    ref?: React.ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <button
        ref={ref}
        {...restProps}
        className={twMerge('btn', mode, className)}
        disabled={disabled}
        onClick={onClick}>
        {leftIcon}
        {loading && <Spin className={classNameSvg} />}
        {children ? children : label}
        {icon}
      </button>
    );
  }
);

Button.displayName = 'Button';
